// Drag-and-drop reordering of a list that may be showing only part of itself.
//
// Product availability lets the merchant filter the list down to a single day, but the
// order that gets saved belongs to the whole category. Dragging within a filtered list
// therefore only reshuffles the on-screen rows between the slots those rows already
// occupied - every row hidden by the filter keeps the position it had.

// `fullList` is every item in the category, already in saved order. `visibleIds` is the
// ids of the on-screen rows in their new order (read off the DOM after the drag).
// Ids missing from `fullList` are ignored.
export function reorderVisibleSubset(fullList, visibleIds, idOf = item => item.id) {
  const byId = new Map(fullList.map(item => [idOf(item), item]))
  const moved = visibleIds.map(id => byId.get(id)).filter(Boolean)
  const movedIds = new Set(moved.map(idOf))

  let next = 0
  return fullList.map(item => (movedIds.has(idOf(item)) ? moved[next++] : item))
}

// Writes each item's new position back onto the item itself. The rendered list is sorted
// by `order` on every render, so without this the list still carries the orders it was
// loaded with and snaps back to the pre-drag order as soon as anything re-renders -
// switching day tabs, say - until the page is reloaded.
export function renumberOrder(orderedList) {
  orderedList.forEach((item, index) => (item.order = index + 1))
  return orderedList
}

// The payload the categories endpoint expects: every pair with a 1-based order.
// Sending the full list (not just the visible rows) is what keeps a filtered drag from
// renumbering on-screen rows into slots the hidden ones already hold.
export function orderedPairsPayload(orderedList, idOf = item => item.id) {
  return orderedList.map((item, index) => ({ id: idOf(item), order: index + 1 }))
}
